import "./styles/Profile.css";
import "./styles/Images.css";
import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import { GetProfileData } from "./GetProfileData";
import { useAuth } from "../hooks/Auth";
import ChangeProfilePic from "../components/ChangeProfilePic";

const SUPABASE_URL = "https://cjbfyxwdlcitbuxrwvpb.supabase.co/storage/v1/object/public/image-uploads/";

const ProfilePage = () => {
  const { state } = useLocation();
  const { token, user } = useAuth();
  const [showChangeProfilePic, setShowChangeProfilePic] = useState(false);
  const username = state?.user;
  const imageCount = 8;
  const [imageIndex, setImageIndex] = useState(0);
  const [posts, setPosts] = useState([]);
  const [profile, setProfile] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const navigate = useNavigate();
  const defaultProfilePic = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR_nLCu85ayoTKwYw6alnvrockq5QBT2ZWR2g&s";
  

  useEffect(() => {
    if (!username) {
      navigate("/gallery");
      return;
    }
    async function loadProfile() {
      const profileData = await GetProfileData(username, undefined, undefined);
      const postsData = await GetProfileData(username, imageIndex, imageCount);
      console.log("profileData:", profileData);
      console.log("postsData:", postsData);
      setProfile(profileData[0] || null);
      setPosts(postsData);
    }

    loadProfile();
  }, [username, imageIndex, refreshKey, navigate]);

  const paddedImages = [
    ...posts,
    ...Array(Math.max(imageCount - posts.length, 0)).fill(null)
  ];

  const isLastPage = posts.length < imageCount;
  const isFirstPage = imageIndex === 0;

  const handleDelete = async (postId) => {
    const response = await fetch(`/api/gallery/posts?id=${postId}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token?.access_token}`,
      },
    });

    if (response.ok) {
      setPosts((prev) => prev.filter((img) => img.id !== postId));
    }
  };

  return (
    <div className="container">
      <div>
      {showChangeProfilePic && <ChangeProfilePic onClose={() => { setShowChangeProfilePic(false); setRefreshKey(prev => prev + 1); }} />}

        <div className="profile-header">
          <h1 className="profile-title">
          Profile
          </h1>
        </div>
        <div className="controls-bar">
          <button
          className="file-button"
          onClick={() => navigate("/login")}
        >
          Logout
        </button>
        <button
          className="file-button"
          onClick={() => navigate("/editor")}
        >
          Canvas
        </button>
        <button
          className="file-button"
          onClick={() => navigate("/gallery")}
        >
          Gallery
        </button>
        <div style={{ flex: 1 }} />
          <div> {username === user?.id ? (
          <button
            className="file-button"
            onClick={() => { if (token) setShowChangeProfilePic(true);}}>
              Change Profile Pic
          </button>
          ) : null}
          </div>
        </div>
      <img className="profile-image" 
        src={profile?.profile_pic ? `${SUPABASE_URL}${profile.profile_pic}?t=${Date.now()}` : defaultProfilePic} 
        alt={profile ? profile.username : "Profile Image"}
      />
      
      <div className="profile-username">
        <h1>{profile ? profile.username : "Loading..."}</h1>
        {/* <div> {username === user?.id ? (
          <button
            className="profile-image-change"
            onClick={() => { if (token) setShowChangeProfilePic(true);}}>
              Change Profile Pic
          </button>
          ) : null}
        </div> */}
      </div>

        

      <div className="gallery-display">
        {paddedImages.map((image, index) =>
          image ? (
            <div key={index} className="gallery-item">
              <img
                src={image.thumbnail}
                alt={image.image_name}
                className="gallery-image"
                onClick={() =>
                  navigate("/post", { state: { post: image } })
                }
              />
              <div className="image-overlay">
                <p className="image-name">{image.image_name}</p>
                <p className="image-author">{image.profiles.username}</p>
                {image.creator === user?.id && (
                  <button onClick={(e) => { e.stopPropagation(); handleDelete(image.id); }}>
                    Delete
                  </button>
                )}
              </div>
            </div>
          ) : (
            <div key={index} className="gallery-placeholder"></div>
          )
        )}
      </div>

        <div className="gallery-buttons">

        <button
          className="previous-button"
          disabled={isFirstPage}
          onClick={() =>
            setImageIndex((prev) => Math.max(prev - imageCount, 0))
          }
        >
          Previous
        </button>

        <button
          className="next-button"
          disabled={isLastPage}
          onClick={() => {
            if (!isLastPage) {
              setImageIndex((prev) => prev + imageCount);
            }
          }}
        >
          Next
        </button>

        </div>
      </div>
    </div>
  );
};

export default ProfilePage;
